import { Component } from '@angular/core';

@Component({
  selector: 'app-permission-role-user-add',
  templateUrl: './permission-add.component.html',
  styleUrls: ['./permission-add.component.css']
})
export class PermissionAddComponent {

}
